<div class="wallet-item-container" [ngClass]="{ 'hide-Bottom-Border': hideBottomBorder }">
	<div class="logo-container">
		<img class="asset-logo" [src]="assetLogo" />
		<img class="network-logo" [src]="networkLogo" />
	</div>
	<div class="item">
		<div class="data">
			<div class="owner">
				@if(ownerName) {
					<span class="name">{{ ownerName }}</span>
				}
				@if(draft) {
					<span class="missing-details">{{ "missing_details" | translate }}</span>
				}
			</div>
			<span class="address">{{ walletAddress }}</span>
		</div>
		<span class="network-name">{{ networkName }}</span>
	</div>
</div>